// extracted by mini-css-extract-plugin
module.exports = {"registrationButtonSpacing":"KVLFP","registrationButtonSpacing--noImage":"_3ebmh","registrationButtonSpacingNoImage":"_3ebmh","secondaryButtonSpacing":"_88QIS"};